import http from  '@/http/index'
import {getPlatCordonInfo, getEarthSeaTempInfo,getPipeLineList,getPortList,getDeviceList,
  getCurrentInfo,getSaltInfo,getSeaTemperature,getAirTemperature,
  getWaveInfo,getWaterDeptInfo,getEarthWaveInfo,getEarthWindInfo,getEarthPressureInfo,getEarthCurrentInfo} from "../../http/mapLayer";
  import { getShipList } from '@/http/ship'
import {formatPipeLine , latlngChangeToDMS,checkResponseData,fakeTime} from '../../utils/util'
const USE_MOCK_DATA = true;
import weatherCache from '@/utils/weatherDataCache'
import mockData from "../../mock/data"


import windIcon from "@/assets/map/风场.png";
import temperatureIcon from "@/assets/map/温度.png";
import waveIcon from "@/assets/map/海浪.png";
import seaTemperatureIcon from "@/assets/map/进水温度.png";
import oceanCurrentIcon from "@/assets/map/洋流.png";
import airPressureIcon from "@/assets/map/气压.png";
import salinityIcon from "@/assets/map/盐度.png";
import shipIcon from "@/assets/map/船舶.png";
import pipelineIcon from "@/assets/map/管线.png";
import portIcon from "@/assets/map/港口.png";
import libraryIcon from "@/assets/map/仓库.png";
import latlonIcon from "@/assets/map/经纬网格.png";
import waringLineIcon from "@/assets/map/警戒线.png";


// mutations type

const SET_MAP_TITLE_LAYER_INDEX = "SET_MAP_TITLE_LAYER_INDEX"; // 设置底图 index

const SET_LAYER_FLAG = "SET_LAYER_FLAG"; // 设置数据请求flag
const SET_BASE_LAYER_INDEX = "SET_BASE_LAYER_INDEX"; // 设置气象图层index
const SET_WIND_DATA = "SET_WIND_DATA"; // 设置风场数据
const SET_TEMP_DATA = "SET_TEMP_DATA"; // 设置温度数据
const SET_WAVE_DATA = "SET_WAVE_DATA"; // 设置海浪数据
const SET_CURRENT_DATA = "SET_CURRENT_DATA"; // 设置洋流数据
const SET_SALT_DATA = "SET_SALT_DATA"; // 设置洋流数据
const SET_AIR_PRESSURE_DATA = "SET_AIR_PRESSURE_DATA"; // 设置气压数据
const SET_SEA_TEMPERATURE_DATA = "SET_SEA_TEMPERATURE_DATA"; // 设置海温数据
const SET_AIR_TEMPERATURE_DATA = "SET_AIR_TEMPERATURE_DATA"; // 设气温数据
const SET_HUMIDITY_DATA = "SET_HUMIDITY_DATA"; // 设置湿度数据
const SET_PRECIPITATION_DATA = "SET_PRECIPITATION_DATA"; // 设置降水数据
const LATLON_FLAG = "LATLON_FLAG"; // 经纬度开关
const PORT_FLAG = "PORT_FLAG"; // 港口开关
const DEVICE_FLAG = "DEVICE_FLAG"; // 经纬度开关
const SHIP_FLAG = "SHIP_FLAG"; // 船舶开关
const WARNINGLINE_FLAG = "WARNINGLINE_FLAG"; //警界线开关
const SET_LATLNG = "SET_LATLNG"; //警界线开关
const PIPE_LINE_FLAG = "PIPE_LINE_FLAG"; //管线开关
const SET_WATER_DEEP_DATA = 'SET_WATER_DEEP_DATA'; //当前水深

const SET_MAP_EVENTS_DATA = 'SET_MAP_EVENTS_DATA'; //地图事件数据

const TOGGLE_WARNINGLINE_SWITCH = 'TOGGLE_WARNINGLINE_SWITCH'; //切换警戒圈 内部颜色 显示
const TOGGLE_VECTOR_SWITCH = 'TOGGLE_VECTOR_SWITCH'; // 切换 矢量动画 是否 显示


export default {
  namespaced:true,
  state: {
    /*地图 state*/
    map:{
      titleLayers:[
        {url:'https://webrd01.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=8&x={x}&y={y}&z={z}'}, // 高德矢量（简洁版）
        {url:'https://webrd01.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=7&x={x}&y={y}&z={z}'}, // 高德矢量（标准版）
        {url:'https://webst01.is.autonavi.com/appmaptile?style=6&x={x}&y={y}&z={z}'}, // 高德卫星
        {url:'https://tile.openstreetmap.org/{z}/{x}/{y}.png'}, // OpenStreetMap
      ],
      currentTimeIndex: 0,  // 添加这一行
      currentTimestamp: null,  
      titleLayerIndex:0, // 默认使用高德矢量 // 默认底图
      baseLayer : [ // 基础图层列表
        {layerType:'setWindData',layerIcon:windIcon,layerName:'风速',active:false},
        // {layerType:'setAirTemperatureData',layerIcon:temperatureIcon,layerName:'气温',active:false},
        {layerType:'setWaveData',layerIcon:waveIcon,layerName:'温度',active:false},
        {layerType:'setSeaTemperatureData',layerIcon: seaTemperatureIcon,layerName:'湿度',active:false},
        {layerType:'setCurrentData',layerIcon: oceanCurrentIcon,layerName:'降水',active:false},
        //{layerType:'setAirPressureData',layerIcon: airPressureIcon,layerName:'气压',active:false},
        //{layerType:'setSaltData',layerIcon: salinityIcon,layerName:'盐度',active:false},
      ],
      baseLayerV1 : [ // 基础图层列表
        {layerType:'setWindDataV1',layerIcon:windIcon,layerName:'风速',layerKey:'wind',active:true},
        {layerType:'setTempDataV1',layerIcon:temperatureIcon,layerName:'温度',layerKey:'temperature',active:false},
        {layerType:'setHumidityDataV1',layerIcon: seaTemperatureIcon,layerName:'湿度',layerKey:'humidity',active:false},
        {layerType:'setPrecipitationDataV1',layerIcon: oceanCurrentIcon,layerName:'降水',layerKey:'precipitation',active:false},
      ],
      deviceLayerV1 :[ // 设备图层列表
        {layerType:'PORT_FLAG',layerIcon:portIcon,layerName:'港口',layerKey:'port',active:false},
        {layerType:'LATLON_FLAG',layerIcon:latlonIcon,layerName:'经纬网',layerKey:'latlng',active:false},
      ],
      baseLayerIndex:0, // 气象图层 激活index
      layerFlag:true,  // 图层数据开关
      windFlag:true, // 风场开关
      waveFlag:false, // 海浪开关
      currentFlag:false, // 洋流开关
      saltFlag:false, // 盐度开关
      airPressureFlag:false, // 气压开关
      heatmapFlag:false, // 热力图开关
      seaTemperatureFlag:false, // 海温开关
      airTemperatureFlag:false, // 气温开关
      latlngFlag:false, //经纬度开关
      deviceFlag: false, // 设备库开关
      shipDeviceFlag: false, // 船舶开关
      portFlag: false, // 港口开关
      warningLineFlag:true, // 警戒线开关
      pipeLineFlag:false, // 管线开关
      windData:[],
      windDataCache: new Map(), // 风场数据缓存
      tempData:[],
      tempDataCache: new Map(), // 温度数据缓存
      loadingTempData: false, // 温度数据加载状态
      humidityData:[],
      humidityDataCache: new Map(), // 湿度数据缓存
      loadingHumidityData: false, // 湿度数据加载状态
      precipitationData:[],
      precipitationDataCache: new Map(), // 降水数据缓存
      loadingPrecipitationData: false, // 降水数据加载状态
      loadingWindData: false, // 风场数据加载状态
      windHotData:[],
      waveData:null,
      waveHotData:null,
      currentData:null,
      currentHotData:null,
      saltData:null,
      heatmapData:null,
      airPressureData:null,
      seaTemperatureData:null,
      airTemperatureData:null,
      portData:null,
      deviceData:null,
      shipData:null,
      warningLineData:null,
      currentLat:0.0,
      currentLng:0.0,
      currentDeep:{
        data:'--',
        lat:'',
        lng:''
      },
      pipeLineData:null,
      legendShow: '', // 控制图例显示
      eventsData:null, // 地图事件data  json
      saveEventsFlag:false, // 地图事件 保存开关
      loadEventsFlag:false, // 地图事件 读取开关
    },
    style:{
      warningLineSwitch:true, // 全局 图层 警戒圈 颜色开关
      vectorAnimateSwitch:true, // 全局 图层 矢量动画 开关
    }
  },

  mutations: {
    [SET_MAP_TITLE_LAYER_INDEX](state,payload){
      state.map.titleLayerIndex = payload
      // state.map.saveEventsFlag = payload.flag
    },
    [SET_MAP_EVENTS_DATA](state,payload){
      //console.log('拿到的payload：' , payload)
      state.map.eventsData = payload.data
      state.map.saveEventsFlag = payload.flag
    },
    
    [TOGGLE_WARNINGLINE_SWITCH](state,payload){
      state.style.warningLineSwitch = payload
    },
    [TOGGLE_VECTOR_SWITCH](state,payload){
      state.style.vectorAnimateSwitch = payload
    },
    [SET_BASE_LAYER_INDEX](state,payload){
      if (state.map.baseLayerIndex == payload.index && payload.flag){
        state.map.baseLayerIndex = null
      }else{
        state.map.baseLayerIndex = payload.index
      }
      state.map.baseLayer[payload.index].active = !payload.flag;
      state.map.baseLayerV1[payload.index].active = !payload.flag;
    },
    [SET_LAYER_FLAG](state,payload){
      state.map.layerFlag = payload;
    },
    [SET_WIND_DATA](state,payload){
      state.map.windFlag = !payload.flag;
      // ✅ 这里 payload.data 应该直接是数组，不需要再解析
      state.map.windData = payload.data;
      state.map.windHotData = payload.hotData;
    },
    [SET_WAVE_DATA](state,payload){
      state.map.waveFlag = !payload.flag;
      state.map.waveData = payload.data;
      state.map.waveHotData = payload.hotData;
    },
    [SET_CURRENT_DATA](state,payload){
      state.map.currentFlag = !payload.flag;
      state.map.currentData = payload.data;
      state.map.currentHotData = payload.hotData;
    },
    [SET_SALT_DATA](state,payload){
      state.map.saltFlag = !payload.flag;
      state.map.saltData = payload.data;
    },
    [SET_AIR_PRESSURE_DATA](state,payload){
      state.map.airPressureFlag = !payload.flag;
      state.map.airPressureData = payload.data;
    },
    [SET_SEA_TEMPERATURE_DATA](state,payload){
      state.map.seaTemperatureFlag = !payload.flag;
      state.map.seaTemperatureData= payload.data;
    },
    [SET_AIR_TEMPERATURE_DATA](state,payload){
      state.map.airTemperatureFlag = !payload.flag;
      state.map.airTemperatureData= payload.data;
    },
    [LATLON_FLAG](state){
      state.map.latlngFlag = !state.map.latlngFlag;
    },
    [PORT_FLAG](state,payload){
      state.map.portFlag = !payload.flag;
      state.map.portData = payload.data;
    },
    [DEVICE_FLAG](state,payload){
      state.map.deviceFlag = !payload.flag;
      state.map.deviceData = payload.data;
    },
    [SHIP_FLAG](state,payload){
      state.map.shipDeviceFlag = !payload.flag;
      state.map.shipData = payload.data;
    },
    [WARNINGLINE_FLAG](state,payload){
      state.map.warningLineFlag = !payload.flag;
      state.map.warningLineData = payload.data;
    },
    [SET_LATLNG](state,payload){
      state.map.currentLat = latlngChangeToDMS(payload.lat);
      state.map.currentLng = latlngChangeToDMS(payload.lng);
    },
    [PIPE_LINE_FLAG](state,payload){
      state.map.pipeLineFlag = !payload.flag;
      state.map.pipeLineData = payload.data;
    },
    [SET_WATER_DEEP_DATA](state,payload){
      state.map.currentDeep.data = payload.data;
      state.map.currentDeep.lat = latlngChangeToDMS(payload.lat);
      state.map.currentDeep.lng = latlngChangeToDMS(payload.lng);
    },
    'SET_LEGEND_CHANGE'(state, payload) {
      const { type } = payload
      state.map.legendShow = type
    },
    'SET_SAVE_EVENTS_FLAG_TRUE' (state, payload) {
      state.map.saveEventsFlag = true
    },
    'SET_LOADING_EVENTS_FLAG_TRUE' (state, payload) {
      state.map.loadEventsFlag = true
    },
    'SET_LOADING_EVENTS_FLAG_FALSE' (state, payload) {
      state.map.loadEventsFlag = false
    },
    'SET_LOADING_WIND_DATA' (state, loading) {
      state.map.loadingWindData = loading
    },
    'SET_WIND_DATA_CACHE' (state, {fileName, data}) {
      state.map.windDataCache.set(fileName, data)
    },
    'CLEAR_WIND_DATA_CACHE' (state) {
      state.map.windDataCache.clear()
    }
    
    ,
    [SET_TEMP_DATA](state,payload){
      state.map.tempFlag = !payload.flag;
      state.map.tempData = payload.data;
    },
    [SET_HUMIDITY_DATA](state,payload){
      state.map.humidityFlag = !payload.flag;
      state.map.humidityData = payload.data;
    },
    'SET_LOADING_TEMP_DATA' (state, loading) {
      state.map.loadingTempData = loading
    },
    'SET_TEMP_DATA_CACHE' (state, {fileName, data}) {
      state.map.tempDataCache.set(fileName, data)
    },
    'CLEAR_TEMP_DATA_CACHE' (state) {
      state.map.tempDataCache.clear()
    },
    [SET_HUMIDITY_DATA](state,payload){
      state.map.humidityFlag = !payload.flag;
      state.map.humidityData = payload.data;
    },
    'SET_LOADING_HUMIDITY_DATA' (state, loading) {
      state.map.loadingHumidityData = loading
    },
    'SET_HUMIDITY_DATA_CACHE' (state, {fileName, data}) {
      state.map.humidityDataCache.set(fileName, data)
    },
    'CLEAR_HUMIDITY_DATA_CACHE' (state) {
      state.map.humidityDataCache.clear()
    },
    [SET_PRECIPITATION_DATA](state,payload){
      state.map.precipitationFlag = !payload.flag;
      state.map.precipitationData = payload.data;
    },
    'SET_LOADING_PRECIPITATION_DATA' (state, loading) {
      state.map.loadingPrecipitationData = loading
    },
    'SET_PRECIPITATION_DATA_CACHE' (state, {fileName, data}) {
      state.map.precipitationDataCache.set(fileName, data)
    },
    'CLEAR_PRECIPITATION_DATA_CACHE' (state) {
      state.map.precipitationDataCache.clear()
    },
    'SET_CURRENT_TIME_INDEX'(state, payload) {
      state.map.currentTimeIndex = payload.index;
      state.map.currentTimestamp = payload.timestamp;
    },
  },
  actions: {
    setWindData(context,payload){
      if (!payload.flag){
        context.commit('SET_LAYER_FLAG',false)
        let t = Number(payload.time)
        // let d1 = http.get(getWindInfo,{time:t || 1519884000000 })
        let d1 = http.get(getEarthWindInfo,{time:t || 1519884000000 })  // 全球数据
        // let d2 = http.get(getWindHotInfo,{time:t || 1519884000000 })
        Promise.all([d1]).then((value) =>{
          //console.log('Promise==>',value)

          if (!checkResponseData(value)){
            context.commit('SET_LAYER_FLAG',true)
            return false
          }
          let data1 = JSON.parse(value[0].data);
          // let data2 = JSON.parse(value[1].data);
          payload.data = data1.dataJson;
          // payload.hotData = data2;

          context.commit('SET_BASE_LAYER_INDEX',payload)
          context.commit('SET_WIND_DATA',payload)
          context.commit('SET_LAYER_FLAG',true)
        })
      }else{
        payload.data = null
        payload.hotData = null
        context.commit('SET_WIND_DATA',payload)
        context.commit('SET_LAYER_FLAG',true)
        context.commit('SET_BASE_LAYER_INDEX',payload)
      }
      console.log(payload)
    },
    // 动态加载风场数据
    // 动态加载风场数据
    // 动态加载风场数据
    // 修改 store/modules/moduleMap.js 中的 loadWindDataByTime
    // 修改 loadWindDataByTime 方法
    async loadWindDataByTime({ commit }, timestamp) {
      try {
        console.log('=== 加载风场数据 - 自动查找最新日期文件夹 ===');
        console.log('原始时间戳:', timestamp);
        
        const numericTimestamp = parseInt(timestamp);
        if (isNaN(numericTimestamp)) {
          throw new Error(`无效的时间戳: ${timestamp}`);
        }
        
        const date = new Date(numericTimestamp);
        console.log('CST时间:', date.toLocaleString('zh-CN'));
        console.log('对应UTC时间:', date.toISOString());
        
        const year = date.getUTCFullYear();
        const month = String(date.getUTCMonth() + 1).padStart(2, '0');
        const day = String(date.getUTCDate()).padStart(2, '0');
        const hour = String(date.getUTCHours()).padStart(2, '0');
        
        const fileName = `${year}${month}${day}_${hour}00.json.gz`;
        const cacheKey = `wind_${fileName}`;

        // 先尝试从缓存读取
        const cached = await weatherCache.get(cacheKey);
        if (cached) {
          console.log('✅ 从缓存加载风速:', fileName);
          return cached;
        }

        console.log('⬇️ 从网络加载风速:', fileName);
        // 生成过去5天的日期列表（从今天开始往前）
        // 生成日期列表：从(今天-5天)开始，往前找5天
        // 例如今天是10-01，则查找：09-26, 09-25, 09-24, 09-23, 09-22
        const pastDates = [];
        const today = new Date();
        for (let i = 5; i < 25; i++) {  // ✅ 5天前开始，往前找20天
          const date = new Date(today.getTime() - i * 24 * 60 * 60 * 1000);
          const dateStr = `${date.getFullYear()}-${String(date.getMonth()+1).padStart(2,'0')}-${String(date.getDate()).padStart(2,'0')}`;
          pastDates.push(dateStr);
        }
        
        console.log('将尝试以下日期文件夹:', pastDates);
        console.log('查找文件名:', fileName);
        
        // 依次尝试每个日期文件夹
        let response = null;
        let successPath = null;
        
        for (const dateFolder of pastDates) {
          const filePath = `/data/wind/${dateFolder}/${fileName}`;
          try {
            console.log('尝试路径:', filePath);
            response = await fetch(filePath);
            if (response.ok) {
              successPath = filePath;
              console.log('✅ 找到风场数据:', filePath);
              break;
            }
          } catch (err) {
            console.log(`路径 ${filePath} 不存在，继续尝试...`);
            continue;
          }
        }
        
        if (!response || !response.ok) {
          throw new Error(`过去5天内未找到风场数据: ${fileName}`);
        }
        
        console.log('成功路径:', successPath);
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }

        // 导入pako解压库
        const pako = await import('pako');

        // 获取压缩数据
        const compressedData = await response.arrayBuffer();

        // 解压gzip数据
        const decompressedData = pako.ungzip(new Uint8Array(compressedData), { to: 'string' });

        // 解析JSON数据
        const windData = JSON.parse(decompressedData);
        // 存入缓存
        // 存入缓存
        await weatherCache.set(cacheKey, windData);
        console.log('💾 已缓存风速:', fileName);
        // 调试：检查原始解析的数据（安全版本）
        console.log('=== 原始JSON解析数据 ===');
        console.log('数据类型:', typeof windData);
        console.log('是否为数组:', Array.isArray(windData));
        if (Array.isArray(windData)) {
          console.log('数组长度:', windData.length);
          windData.forEach((block, index) => {
            if (block.data && Array.isArray(block.data)) {
              const data = block.data;
              const dataLength = data.length;
              const sample = data.slice(0, 10);
              const lastSample = data.slice(-10);
              
              // 安全地计算统计值（避免栈溢出）
              let max = -Infinity, min = Infinity, sum = 0;
              for (let i = 0; i < Math.min(dataLength, 10000); i++) {
                const val = data[i];
                if (val > max) max = val;
                if (val < min) min = val;
                sum += val;
              }
              const avg = sum / Math.min(dataLength, 10000);
              
              console.log(`数据块${index} - 长度:${dataLength}`);
              console.log(`数据块${index} - 前10个值:`, sample);
              console.log(`数据块${index} - 后10个值:`, lastSample);
              console.log(`数据块${index} - 前10000个值的统计: 最大值:${max}, 最小值:${min}, 平均值:${avg.toFixed(4)}`);
              
              // 检查header信息
              if (block.header) {
                console.log(`数据块${index} - header:`, {
                  nx: block.header.nx,
                  ny: block.header.ny,
                  parameterNumber: block.header.parameterNumber
                });
              }
            }
          });
        }
        console.log('成功加载风场数据:', fileName);
        
        // ✅ 添加详细的数据格式检查
        console.log('=== 数据格式检查 ===');
        console.log('数据类型:', typeof windData);
        console.log('是否为数组:', Array.isArray(windData));
        if (Array.isArray(windData)) {
          console.log('数组长度:', windData.length);
          windData.forEach((item, index) => {
            console.log(`数据块${index}:`, {
              hasHeader: !!item.header,
              hasData: !!item.data,
              dataType: typeof item.data,
              dataLength: Array.isArray(item.data) ? item.data.length : 'not array'
            });
            if (item.header) {
              console.log(`数据块${index}的header:`, item.header);
            }
          });
        } else {
          console.log('数据内容:', windData);
        }
        
        return windData;
        
      } catch (error) {
        console.error('加载风场数据失败:', error);
        return null;
      }
    },
    async loadTempDataByTime({ commit }, timestamp) {
      try {
        console.log('=== 加载温度数据 - 自动查找最新日期文件夹 ===');
        console.log('时间戳:', timestamp);
        
        const numericTimestamp = parseInt(timestamp);
        const date = new Date(numericTimestamp);
        const year = date.getUTCFullYear();
        const month = String(date.getUTCMonth() + 1).padStart(2, '0');
        const day = String(date.getUTCDate()).padStart(2, '0');
        const hour = String(date.getUTCHours()).padStart(2, '0');
        
        const fileName = `${year}${month}${day}_${hour}00.json.gz`;
        const cacheKey = `temp_${fileName}`;

        // 先尝试从缓存读取
        const cached = await weatherCache.get(cacheKey);
        if (cached) {
          console.log('✅ 从缓存加载温度:', fileName);
          return cached;
        }

        console.log('⬇️ 从网络加载温度:', fileName);
        // 生成日期列表：从(今天-5天)开始，往前找5天
        const pastDates = [];
        const today = new Date();
        for (let i = 5; i < 25; i++) {  // ✅ 5天前开始，往前找20天
          const date = new Date(today.getTime() - i * 24 * 60 * 60 * 1000);
          const dateStr = `${date.getFullYear()}-${String(date.getMonth()+1).padStart(2,'0')}-${String(date.getDate()).padStart(2,'0')}`;
          pastDates.push(dateStr);
        }
        console.log('温度数据 - 尝试日期文件夹:', pastDates);
        console.log('温度数据 - 查找文件名:', fileName);
        
        // 依次尝试每个日期文件夹
        let response = null;
        let successPath = null;
        
        for (const dateFolder of pastDates) {
          const filePath = `/data/temp/${dateFolder}/${fileName}`;
          try {
            console.log('尝试路径:', filePath);
            response = await fetch(filePath);
            if (response.ok) {
              successPath = filePath;
              console.log('✅ 找到温度数据:', filePath);
              break;
            }
          } catch (err) {
            continue;
          }
        }
        
        if (!response || !response.ok) {
          throw new Error(`过去5天内未找到温度数据: ${fileName}`);
        }
        
        console.log('成功路径:', successPath);
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }
    
        const pako = await import('pako');
        const compressedData = await response.arrayBuffer();
        const decompressedData = pako.ungzip(new Uint8Array(compressedData), { to: 'string' });
        const tempData = JSON.parse(decompressedData);
        // 存入缓存
        await weatherCache.set(cacheKey, tempData);
        console.log('💾 已缓存温度:', fileName);
        console.log('温度数据加载成功，数据块数量:', tempData.length);
        return tempData;
        
      } catch (error) {
        console.error('加载温度数据失败:', error);
        return null;
      }
    },
    async loadHumidityDataByTime({ commit }, timestamp) {
      try {
        console.log('=== 加载湿度数据 - 自动查找最新日期文件夹 ===');
        console.log('时间戳:', timestamp);
        
        const numericTimestamp = parseInt(timestamp);
        const date = new Date(numericTimestamp);
        const year = date.getUTCFullYear();
        const month = String(date.getUTCMonth() + 1).padStart(2, '0');
        const day = String(date.getUTCDate()).padStart(2, '0');
        const hour = String(date.getUTCHours()).padStart(2, '0');
        
        const fileName = `${year}${month}${day}_${hour}00.json.gz`;
        const cacheKey = `humidity_${fileName}`;

        // 先尝试从缓存读取
        const cached = await weatherCache.get(cacheKey);
        if (cached) {
          console.log('✅ 从缓存加载湿度:', fileName);
          return cached;
        }

        console.log('⬇️ 从网络加载湿度:', fileName);
        // 生成过去5天的日期列表
        // 生成日期列表：从(今天-5天)开始，往前找5天
        const pastDates = [];
        const today = new Date();
        for (let i = 5; i < 25; i++) {  // ✅ 5天前开始，往前找20天
          const date = new Date(today.getTime() - i * 24 * 60 * 60 * 1000);
          const dateStr = `${date.getFullYear()}-${String(date.getMonth()+1).padStart(2,'0')}-${String(date.getDate()).padStart(2,'0')}`;
          pastDates.push(dateStr);
        }
        
        console.log('湿度数据 - 尝试日期文件夹:', pastDates);
        
        // 依次尝试每个日期文件夹
        let response = null;
        let successPath = null;
        
        for (const dateFolder of pastDates) {
          const filePath = `/data/sq/${dateFolder}/${fileName}`;
          try {
            console.log('尝试路径:', filePath);
            response = await fetch(filePath);
            if (response.ok) {
              successPath = filePath;
              console.log('✅ 找到湿度数据:', filePath);
              break;
            }
          } catch (err) {
            continue;
          }
        }
        
        if (!response || !response.ok) {
          throw new Error(`过去5天内未找到湿度数据: ${fileName}`);
        }
        
        console.log('成功路径:', successPath);
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }
    
        const pako = await import('pako');
        const compressedData = await response.arrayBuffer();
        const decompressedData = pako.ungzip(new Uint8Array(compressedData), { to: 'string' });
        const humidityData = JSON.parse(decompressedData);
        // 存入缓存
        await weatherCache.set(cacheKey, humidityData);
        console.log('💾 已缓存湿度:', fileName);
        console.log('湿度数据加载成功，数据块数量:', humidityData.length);
        return humidityData;
        
      } catch (error) {
        console.error('加载湿度数据失败:', error);
        return null;
      }
    },
    async loadPrecipitationDataByTime({ commit }, timestamp) {
      try {
        console.log('=== 加载降水数据 - 自动查找最新日期文件夹 ===');
        console.log('时间戳:', timestamp);
        
        const numericTimestamp = parseInt(timestamp);
        const date = new Date(numericTimestamp);
        const year = date.getUTCFullYear();
        const month = String(date.getUTCMonth() + 1).padStart(2, '0');
        const day = String(date.getUTCDate()).padStart(2, '0');
        const hour = String(date.getUTCHours()).padStart(2, '0');
        
        const fileName = `${year}${month}${day}_${hour}00.json.gz`;
        const cacheKey = `precipitation_${fileName}`;

        // 先尝试从缓存读取
        const cached = await weatherCache.get(cacheKey);
        if (cached) {
          console.log('✅ 从缓存加载降水:', fileName);
          return cached;
        }

        console.log('⬇️ 从网络加载降水:', fileName);
        // 生成日期列表：从(今天-5天)开始，往前找5天
        const pastDates = [];
        const today = new Date();
        for (let i = 5; i < 25; i++) {  // ✅ 5天前开始，往前找20天
          const date = new Date(today.getTime() - i * 24 * 60 * 60 * 1000);
          const dateStr = `${date.getFullYear()}-${String(date.getMonth()+1).padStart(2,'0')}-${String(date.getDate()).padStart(2,'0')}`;
          pastDates.push(dateStr);
        }
        
        console.log('降水数据 - 尝试日期文件夹:', pastDates);
        
        // 依次尝试每个日期文件夹
        let response = null;
        let successPath = null;
        
        for (const dateFolder of pastDates) {
          const filePath = `/data/precipitation/${dateFolder}/${fileName}`;
          try {
            console.log('尝试路径:', filePath);
            response = await fetch(filePath);
            if (response.ok) {
              successPath = filePath;
              console.log('✅ 找到降水数据:', filePath);
              break;
            }
          } catch (err) {
            continue;
          }
        }
        
        if (!response || !response.ok) {
          throw new Error(`过去5天内未找到降水数据: ${fileName}`);
        }
        
        console.log('成功路径:', successPath);
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }
    
        const pako = await import('pako');
        const compressedData = await response.arrayBuffer();
        const decompressedData = pako.ungzip(new Uint8Array(compressedData), { to: 'string' });
        const precipitationData = JSON.parse(decompressedData);
        // 存入缓存
        await weatherCache.set(cacheKey, precipitationData);
        console.log('💾 已缓存降水:', fileName);
        console.log('降水数据加载成功，数据块数量:', precipitationData.length);
        return precipitationData;
        
      } catch (error) {
        console.error('加载降水数据失败:', error);
        return null;
      }
    },
    async setWindDataV1(context,payload){
      console.log('=== setWindDataV1 被调用 ===');
      console.log('payload.flag:', payload.flag);
      console.log('payload.time:', payload.time);
      console.log('payload.index:', payload.index);
      
      if (!payload.flag){
        context.commit('SET_LAYER_FLAG',false)
        context.commit('SET_BASE_LAYER_INDEX',payload)
        
        try {
          let windData = null;
          
          if (payload.time) {
            windData = await context.dispatch('loadWindDataByTime', payload.time);
            console.log('=== setWindDataV1 收到的数据 ===');
            console.log('调用来源跟踪 - 当前调用栈');
            console.trace('setWindDataV1 调用栈');
            console.log('windData:', windData);
            console.log('windData 类型:', typeof windData);
            console.log('windData 是否为null:', windData === null);
            
            // ✅ 更宽松的验证，先看看数据是什么样的
            if (!windData) {
              console.error('风场数据为空，跳过图层更新');
              return;
            }
            
            if (!Array.isArray(windData)) {
              console.error('风场数据不是数组，实际类型:', typeof windData);
              console.error('数据内容:', windData);
              return;
            }
            
            if (windData.length === 0) {
              console.error('风场数据数组为空');
              return;
            }
            
            console.log('数据验证通过，准备设置到store');
            payload.data = windData;
            context.commit('SET_WIND_DATA',payload)
            context.commit('SET_LAYER_FLAG',true)
          }
          
        } catch (error) {
          console.error('风场数据加载失败:', error);
          context.commit('SET_LOADING_WIND_DATA', false);
          return;
        }
      } else {
        // 关闭图层
        payload.data = null
        payload.hotData = null
        context.commit('SET_WIND_DATA',payload)
        context.commit('SET_LAYER_FLAG',true)
        context.commit('SET_BASE_LAYER_INDEX',payload)
      }
    },
    
    // ✅ 添加创建测试数据的方法
    createTestWindData() {
      const nx = 360, ny = 180;
      const dataSize = nx * ny;
      
      return [
        {
          header: {
            parameterCategory: 2,
            parameterNumber: 2, // U分量
            nx: nx,
            ny: ny,
            numberPoints: dataSize,
            lo1: -180.0,
            la1: 90.0,
            lo2: 180.0,
            la2: -90.0,
            dx: 1.0,
            dy: 1.0
          },
          data: new Array(dataSize).fill(0).map(() => Math.random() * 10 - 5) // -5到5的随机风速
        },
        {
          header: {
            parameterCategory: 2,
            parameterNumber: 3, // V分量
            nx: nx,
            ny: ny,
            numberPoints: dataSize,
            lo1: -180.0,
            la1: 90.0,
            lo2: 180.0,
            la2: -90.0,
            dx: 1.0,
            dy: 1.0
          },
          data: new Array(dataSize).fill(0).map(() => Math.random() * 10 - 5)
        }
      ];
    },
    setWaveData(context,payload){
      if (!payload.flag){
        console.log('=== 开始处理风场数据加载 ===');
        if (context.state.map.loadingWindData) {
          console.log('风场数据正在加载中，跳过重复请求');
          return;
        }
        context.commit('SET_LOADING_WIND_DATA', true);
        context.commit('SET_LAYER_FLAG',false)
        let t = Number(payload.time)
        let d1 = http.get(getEarthWaveInfo,{time:t || 1519833600000 })
        // let d2 = http.get(getWaveHotInfo,{time:t || 1519833600000 })
        Promise.all([d1]).then((value) => {

          console.log('Promise==>', value)
          if (!checkResponseData(value)){
            context.commit('SET_LAYER_FLAG',true)
            return false
          }
          let data1 = JSON.parse(value[0].data);
          // let data2 = JSON.parse(value[1].data);
          payload.data = data1.dataJson;
          // payload.hotData = data2;
          context.commit('SET_BASE_LAYER_INDEX',payload)
          context.commit('SET_WAVE_DATA', payload)
          context.commit('SET_LAYER_FLAG', true)
        })
      }else{
        payload.data = []
        payload.hotData = []
        context.commit('SET_WAVE_DATA',payload)
        context.commit('SET_LAYER_FLAG',true)
        context.commit('SET_BASE_LAYER_INDEX',payload)
      }
      console.log(payload)
    },
    setWaveDataV1(context,payload){
      if (!payload.flag){
        context.commit('SET_LAYER_FLAG',false)
        console.log(mockData.windData)
        const dat = JSON.parse(mockData.seaWaveData.data)
          payload.data = dat.dataJson;
        context.commit('SET_LAYER_FLAG', true)
        context.commit('SET_BASE_LAYER_INDEX',payload)
        context.commit('SET_WAVE_DATA', payload)
      }else{
        payload.data = []
        payload.hotData = []
        context.commit('SET_LAYER_FLAG',true)
        context.commit('SET_WAVE_DATA',payload)
        context.commit('SET_BASE_LAYER_INDEX',payload)
      }
      console.log(payload)
    },
    async setTempDataV1(context,payload){
      console.log('=== setTempDataV1 被调用 ===');
      console.log('payload:', payload);
      
      if (!payload.flag){
        context.commit('SET_LAYER_FLAG',false)
        context.commit('SET_BASE_LAYER_INDEX',payload)
        
        try {
          let tempData = null;
          
          if (payload.time) {
            tempData = await context.dispatch('loadTempDataByTime', payload.time);
            console.log('温度数据:', tempData);
            
            if (!tempData || !Array.isArray(tempData) || tempData.length === 0) {
              console.error('温度数据无效');
              return;
            }
            
            payload.data = tempData;
            context.commit('SET_TEMP_DATA',payload)
            context.commit('SET_LAYER_FLAG',true)
          }
          
        } catch (error) {
          console.error('温度数据加载失败:', error);
          return;
        }
      } else {
        payload.data = null
        context.commit('SET_TEMP_DATA',payload)
        context.commit('SET_LAYER_FLAG',true)
        context.commit('SET_BASE_LAYER_INDEX',payload)
      }
    },
    async setHumidityDataV1(context,payload){
      console.log('=== setHumidityDataV1 被调用 ===');
      console.log('payload:', payload);
      
      if (!payload.flag){
        context.commit('SET_LAYER_FLAG',false)
        context.commit('SET_BASE_LAYER_INDEX',payload)
        
        try {
          let humidityData = null;
          
          if (payload.time) {
            humidityData = await context.dispatch('loadHumidityDataByTime', payload.time);
            console.log('湿度数据:', humidityData);
            
            if (!humidityData || !Array.isArray(humidityData) || humidityData.length === 0) {
              console.error('湿度数据无效');
              return;
            }
            
            payload.data = humidityData;
            context.commit('SET_SEA_TEMPERATURE_DATA',payload)
            context.commit('SET_LAYER_FLAG',true)
          }
          
        } catch (error) {
          console.error('湿度数据加载失败:', error);
          return;
        }
      } else {
        payload.data = null
        context.commit('SET_SEA_TEMPERATURE_DATA',payload)
        context.commit('SET_LAYER_FLAG',true)
        context.commit('SET_BASE_LAYER_INDEX',payload)
      }
    },
    async setPrecipitationDataV1(context,payload){
      console.log('=== setPrecipitationDataV1 被调用 ===');
      console.log('payload:', payload);
      
      if (!payload.flag){
        context.commit('SET_LAYER_FLAG',false)
        context.commit('SET_BASE_LAYER_INDEX',payload)
        
        try {
          let precipitationData = null;
          
          if (payload.time) {
            precipitationData = await context.dispatch('loadPrecipitationDataByTime', payload.time);
            console.log('降水数据:', precipitationData);
            
            if (!precipitationData || !Array.isArray(precipitationData) || precipitationData.length === 0) {
              console.error('降水数据无效');
              return;
            }
            
            payload.data = precipitationData;
            context.commit('SET_PRECIPITATION_DATA',payload)
            context.commit('SET_LAYER_FLAG',true)
          }
          
        } catch (error) {
          console.error('降水数据加载失败:', error);
          return;
        }
      } else {
        payload.data = null
        context.commit('SET_PRECIPITATION_DATA',payload)
        context.commit('SET_LAYER_FLAG',true)
        context.commit('SET_BASE_LAYER_INDEX',payload)
      }
    },
    setCurrentData(context,payload){
      if (!payload.flag){
        context.commit('SET_LAYER_FLAG',false)
        let t = Number(payload.time)
        let testTime = fakeTime(t)
        let d1 = http.get(getEarthCurrentInfo,{time:testTime || 1519747200000 })
        // let d2 = http.get(getCurrentHotInfo,{time:t || 1519747200000 })
        Promise.all([d1]).then((value) => {
          console.log('Promise==>', value)

          if (!checkResponseData(value)){
            context.commit('SET_LAYER_FLAG',true)
            return false
          }
          let data1 = JSON.parse(value[0].data);
          // let data2 = JSON.parse(value[1].data);
          payload.data = data1.dataJson;
          // payload.hotData = data2;
          context.commit('SET_BASE_LAYER_INDEX',payload)
          context.commit('SET_CURRENT_DATA', payload)
          context.commit('SET_LAYER_FLAG', true)
        })

      }else{
        payload.data = []
        payload.hotData = []
        context.commit('SET_CURRENT_DATA',payload)
        context.commit('SET_LAYER_FLAG',true)
        context.commit('SET_BASE_LAYER_INDEX',payload)
      }
      console.log(payload)
    },
    setCurrentDataV1(context,payload){
      if (!payload.flag){
        context.commit('SET_LAYER_FLAG',false)
        const dat = JSON.parse(mockData.seaCurrentData.data)
        payload.data = dat.dataJson;
          context.commit('SET_BASE_LAYER_INDEX',payload)
          context.commit('SET_CURRENT_DATA', payload)
          context.commit('SET_LAYER_FLAG', true)

      }else{
        payload.data = []
        payload.hotData = []
        context.commit('SET_CURRENT_DATA',payload)
        context.commit('SET_LAYER_FLAG',true)
        context.commit('SET_BASE_LAYER_INDEX',payload)
      }
      console.log(payload)
    },
    setAirPressureData(context,payload){
      if (!payload.flag){
        context.commit('SET_LAYER_FLAG',false)
        let t = Number(payload.time)
        // http.get(getAirPressure,{time:t || 1519833600000}).then((data)=>{
        http.get(getEarthPressureInfo,{time:t || 1519833600000}).then((data)=>{
          console.log(data)
          if (!checkResponseData(data)){
            context.commit('SET_LAYER_FLAG',true)
            return false
          }
          let temp = JSON.parse(data.data)
          // temp.dataJson[0].data.map((v,i)=>{
          //   return v = v * 0.01
          // })
          payload.data = temp.dataJson
          context.commit('SET_BASE_LAYER_INDEX',payload)

          context.commit('SET_AIR_PRESSURE_DATA',payload)
          context.commit('SET_LAYER_FLAG',true)
        })
      }else{
        payload.data = []
        context.commit('SET_AIR_PRESSURE_DATA',payload)
        context.commit('SET_LAYER_FLAG',true)
        context.commit('SET_BASE_LAYER_INDEX',payload)

      }
      console.log(payload)
    },
    setAirPressureDataV1(context,payload){
      if (!payload.flag){
        context.commit('SET_LAYER_FLAG',false)
        const dat = JSON.parse(mockData.pressureData.data)
        payload.data = dat.dataJson;
          context.commit('SET_BASE_LAYER_INDEX',payload)

          context.commit('SET_AIR_PRESSURE_DATA',payload)
          context.commit('SET_LAYER_FLAG',true)
      }else{
        payload.data = []
        context.commit('SET_AIR_PRESSURE_DATA',payload)
        context.commit('SET_LAYER_FLAG',true)
        context.commit('SET_BASE_LAYER_INDEX',payload)

      }
      console.log(payload)
    },
    setSeaTemperatureData(context,payload){
      if (!payload.flag){
        context.commit('SET_LAYER_FLAG',false)
        let t = Number(payload.time)
        http.get(getEarthSeaTempInfo,{time :t || 1519833600000}).then((data)=>{
          console.log(data)

          if (!checkResponseData(data)){
            context.commit('SET_LAYER_FLAG',true)
            return false
          }
          let temp = JSON.parse(data.data)
          payload.data = temp.dataJson
          context.commit('SET_BASE_LAYER_INDEX',payload)
          context.commit('SET_SEA_TEMPERATURE_DATA',payload)
          context.commit('SET_LAYER_FLAG',true)
        })
      }else{
        payload.data = []
        context.commit('SET_SEA_TEMPERATURE_DATA',payload)
        context.commit('SET_LAYER_FLAG',true)
        context.commit('SET_BASE_LAYER_INDEX',payload)

      }
      console.log(payload)
    },
    setSeaTemperatureDataV1(context,payload){
      if (!payload.flag){
        context.commit('SET_LAYER_FLAG',false)
        const dat = JSON.parse(mockData.temperatureData.data)
        payload.data = dat.dataJson;
          context.commit('SET_BASE_LAYER_INDEX',payload)
          context.commit('SET_SEA_TEMPERATURE_DATA',payload)
          context.commit('SET_LAYER_FLAG',true)

      }else{
        payload.data = []
        context.commit('SET_SEA_TEMPERATURE_DATA',payload)
        context.commit('SET_LAYER_FLAG',true)
        context.commit('SET_BASE_LAYER_INDEX',payload)

      }
      console.log(payload)
    },
    setAirTemperatureData(context,payload){
      if (!payload.flag){
        context.commit('SET_LAYER_FLAG',false)
        let t = Number(payload.time)
        http.get(getAirTemperature,{month:t || 3}).then((data)=>{
          console.log(data)
          if (!checkResponseData(data)){
            context.commit('SET_LAYER_FLAG',true)
            return false
          }
          let temp = JSON.parse(data.data)
          payload.data = temp
          context.commit('SET_BASE_LAYER_INDEX',payload)
          context.commit('SET_AIR_TEMPERATURE_DATA',payload)
          context.commit('SET_LAYER_FLAG',true)
        })
      }else{
        payload.data = []
        context.commit('SET_AIR_TEMPERATURE_DATA',payload)
        context.commit('SET_LAYER_FLAG',true)
        context.commit('SET_BASE_LAYER_INDEX',payload)

      }
      console.log(payload)
    },
    // 查询水深数据
    setWaterDeepData(context,payload){
      let {lat,lng} = payload;
      let obj = {latitude : (+lat).toFixed(1),longitude: (+lng).toFixed(1) }
      http.get(getWaterDeptInfo,{...obj}).then((data)=>{
        console.log(data)
        // if (!checkResponseData(data)){
        //   return false
        // }
        let res = {}
        if (!data.data){
          res.data = '--'
        }else{
          let temp = JSON.parse(data.data)
          res.data = Number(temp).toFixed(2)
        }
        res.lat = payload.lat
        res.lng = payload.lng
        context.commit('SET_WATER_DEEP_DATA',res)
      })
      // console.log(context,payload)
    },

    setSaltData(context,payload){
      if (!payload.flag){
        context.commit('SET_LAYER_FLAG',false)
        let t = Number(payload.time)
        http.get(getSaltInfo,{month:new Date(t).getMonth() + 1 || 1}).then((data)=>{
          // http.get(getSaltInfo,{time:t || 1519833600000}).then((data)=>{
          console.log(data)
          if (!checkResponseData(data)){
            context.commit('SET_LAYER_FLAG',true)
            return false
          }
          let temp = JSON.parse(data.data)
          payload.data = temp.dataJson
          context.commit('SET_BASE_LAYER_INDEX',payload)
          context.commit('SET_SALT_DATA',payload)
          context.commit('SET_LAYER_FLAG',true)
        })
      }else{
        payload.data = []
        context.commit('SET_SALT_DATA',payload)
        context.commit('SET_LAYER_FLAG',true)
        context.commit('SET_BASE_LAYER_INDEX',payload)

      }
      console.log(context,payload)
    },
    setSaltDataV1(context,payload){
      if (!payload.flag){
        context.commit('SET_LAYER_FLAG',false)
        let t = Number(payload.time)
        const dat = JSON.parse(mockData.salinityData.data)
        payload.data = dat.dataJson;
          context.commit('SET_BASE_LAYER_INDEX',payload)
          context.commit('SET_SALT_DATA',payload)
          context.commit('SET_LAYER_FLAG',true)
      }else{
        payload.data = []
        context.commit('SET_SALT_DATA',payload)
        context.commit('SET_LAYER_FLAG',true)
        context.commit('SET_BASE_LAYER_INDEX',payload)

      }
      console.log(context,payload)
    },
    setShipData(context,payload){
      if (context.state.map.shipData != null){
        payload.data = context.state.map.shipData;
        context.commit('SHIP_FLAG',payload)
      }else {
        // todo companyId
        http.post(getShipList).then((data) => {
          console.log(data.data)
          if (!checkResponseData(data)){
            context.commit('SET_LAYER_FLAG',true)
            return false
          }
          // let re = formatPipeLine(data.data)
          payload = Object.assign(payload, {data: [...data.data]})
          context.commit('SHIP_FLAG', payload)
          // console.log(" ====> " ,payload)
        })
      }
    },
    setPortData(context,payload){
      if (context.state.map.portData != null){
        payload.data = context.state.map.portData;
        context.commit('PORT_FLAG',payload)
      }else {
        http.get(getPortList).then((data) => {
          console.log(data.data)
          if (!checkResponseData(data)){
            context.commit('SET_LAYER_FLAG',true)
            return false
          }
          // let re = formatPipeLine(data.data)
          payload = Object.assign(payload, {data: [...data.data]})
          context.commit('PORT_FLAG', payload)
          console.log(" ====> " ,payload)
        })
      }
    },
    setDeviceData(context,payload){
      if (context.state.map.deviceData != null){
        payload.data = context.state.map.deviceData;
        context.commit('DEVICE_FLAG',payload)
      }else {
        // todo companyId
        http.get(getDeviceList,{companyId:184}).then((data) => {
          console.log(data.data)
          if (!checkResponseData(data)){
            context.commit('SET_LAYER_FLAG',true)
            return false
          }
          // let re = formatPipeLine(data.data)
          payload = Object.assign(payload, {data: [...data.data]})
          context.commit('DEVICE_FLAG', payload)
          // console.log(" ====> " ,payload)
        })
      }
    },
    setWarningLineData(context,payload){
      if (context.state.map.warningLineData != null){
        payload.data = context.state.map.warningLineData;
        context.commit('WARNINGLINE_FLAG',payload)
      }else {
        // todo userId
        http.get(getPlatCordonInfo, {userId: 1}).then((data) => {
          console.log(" ====> " ,data.data)
          if (!checkResponseData(data)){
            context.commit('SET_LAYER_FLAG',true)
            return false
          }
          payload = Object.assign(payload, {data: [...data.data]})
          context.commit('WARNINGLINE_FLAG', payload)
        })
      }
    },
    setPipeLineData(context,payload){
      if (context.state.map.pipeLineData != null){
        payload.data = context.state.map.pipeLineData;
        context.commit('PIPE_LINE_FLAG',payload)
      }else {
        http.get(getPipeLineList).then((data) => {
          if (!checkResponseData(data)){
            context.commit('SET_LAYER_FLAG',true)
            return false
          }
          let temp = data.data;
          temp.map((v,i) =>{
            return v.pipelineRoute = formatPipeLine(v.pipelineRoute)
          })
          console.log(temp)
          // let re = formatPipeLine(data.data)
          payload = Object.assign(payload, {data: [...temp]})
          context.commit('PIPE_LINE_FLAG', payload)
          console.log(" ====> " ,payload)
        })
      }
    },
  },
  modules: {

  }
}